import React from 'react';

const blockpassUrl = "https://verify-with.blockpass.org/?clientId=open_campus_0027e&serviceName=OpenCampus&env=prod";

export function KYCBanner(props) {
    const { status, fetchedKYC, connected } = props;

    if(!fetchedKYC || !connected) return null;

    if(fetchedKYC && status) return null;

    return <div id='kyc-banner'>
        <p>You have not completed the KYC process. You will not be able to claim rewards on your staked NFTs until you have passed KYC. <a href={blockpassUrl} target="_blank">Start the process now.</a></p>
    </div>
}